import { RegEdComplianceErrorCode } from './types';

export interface IRegEdLeadTimeOverridePrompt {
	errorCode: RegEdComplianceErrorCode;
	message: string;
	/** Re-runs the original submission with the advisor's reason attached. */
	retry(reason: string): Promise<boolean>;
	/**
	 * The advisor closed the prompt without supplying a reason, so the submission the caller handed over
	 * will never be made. Callers that stood down a retry affordance on handover restore it here.
	 */
	onDismissed?(): void;
}

type Listener = (prompt: IRegEdLeadTimeOverridePrompt) => void;

let listener: Listener | null = null;

/**
 * Routed to one host rather than handled per caller: the submission is filed after its parent is
 * already scheduled, so the flow that started it is often mid-navigation or unmounted by the time the
 * rejection lands. Registering a second listener replaces the first — there is only ever one host.
 */
export const setRegEdLeadTimeOverrideListener = (next: Listener | null) => {
	listener = next;
};

/** No listener means no host is mounted; the caller falls back to surfacing the message itself. */
export const requestRegEdLeadTimeOverride = (prompt: IRegEdLeadTimeOverridePrompt): boolean => {
	listener?.(prompt);
	return !!listener;
};
